import { useAtomValue, useSetAtom } from 'jotai';

import { Stack, Text } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { RangeInput } from '@common/components/filters';

import { dealAmountRangeFilterAtom, updateDealAmountRangeFilterAtom } from '../../atoms/leadsAtoms';

// Default range for deal amount
const DEFAULT_MIN = 0;
const DEFAULT_MAX = 20000;
const STEP = 1000;

/**
 * FiltersDrawerDealAmountSection component that provides deal amount range filtering
 * wrapped in an accordion
 */
export function FiltersDrawerDealAmountSection() {
	const dealAmountRange = useAtomValue(dealAmountRangeFilterAtom);
	const setDealAmountRange = useSetAtom(updateDealAmountRangeFilterAtom);

	// Use default range if no filter is set
	const currentRange = dealAmountRange || { min: DEFAULT_MIN, max: DEFAULT_MAX };

	const handleRangeChange = (range: { min: number; max: number }) => {
		setDealAmountRange(range);
	};

	const formatValue = (value: number) => {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(value);
	};

	// Determine if this section has any applied filters
	const hasAppliedFilters = dealAmountRange !== null && dealAmountRange !== undefined;

	return (
		<AccordionSection title='Deal amount' defaultExpanded={hasAppliedFilters}>
			<Stack itemsSpacing='16'>
				<RangeInput
					type='text'
					ranges={{
						min: {
							limit: DEFAULT_MIN,
							label: 'Min',
							placeholder: formatValue(DEFAULT_MIN),
						},
						max: {
							limit: DEFAULT_MAX,
							label: 'Max',
							placeholder: formatValue(DEFAULT_MAX),
						},
					}}
					value={currentRange}
					onChange={handleRangeChange}
					step={STEP}
					leftContent={<Text size='bodySmall'>$</Text>}
				/>
			</Stack>
		</AccordionSection>
	);
}
